Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactNative = require("react-native-web");
var _styles = require("../../../../styles");
var useStyles = exports.useStyles = function useStyles() {
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    colors = _STYLES$useStyles.colors,
    fontSemiBold = _STYLES$useStyles.fontSemiBold,
    fontRegular = _STYLES$useStyles.fontRegular,
    COLORS = _STYLES$useStyles.COLORS;
  var leaderboardChangeWrapper = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    borderStyle: 'solid',
    borderColor: colors.navBorder,
    borderWidth: (0, _styles.getREM)(0.0625),
    borderRadius: (0, _styles.getREM)(0.625),
    paddingVertical: (0, _styles.getREM)(0.25),
    paddingHorizontal: (0, _styles.getREM)(0.5),
    backgroundColor: COLORS.white
  };
  var leaderboardChangeValue = Object.assign({}, fontSemiBold, {
    fontSize: _styles.STYLES.fontSize.s,
    lineHeight: _styles.STYLES.lineHeight.s,
    color: colors.text
  });
  var leaderboardChangeIconWrapper = {
    marginRight: (0, _styles.getREM)(0.25)
  };
  var leaderboardChangeIconEqual = {
    backgroundColor: COLORS.lochmara,
    width: (0, _styles.getREM)(1),
    height: (0, _styles.getREM)(0.3125)
  };
  var leaderboardChangeUnit = Object.assign({}, fontRegular, {
    fontSize: _styles.STYLES.fontSize.s,
    lineHeight: _styles.STYLES.lineHeight.s,
    color: colors.text,
    marginLeft: (0, _styles.getREM)(0.25)
  });
  var styles = _reactNative.StyleSheet.create({
    leaderboardChangeWrapper: leaderboardChangeWrapper,
    leaderboardChangeValue: leaderboardChangeValue,
    leaderboardChangeIconWrapper: leaderboardChangeIconWrapper,
    leaderboardChangeIconEqual: leaderboardChangeIconEqual,
    leaderboardChangeUnit: leaderboardChangeUnit
  });
  return {
    styles: styles
  };
};